import React from 'react';

interface AppointmentsIconProps {
  className?: string;
  isActive?: boolean;
  size?: number;
}

export const AppointmentsIcon: React.FC<AppointmentsIconProps> = ({ 
  className = '', 
  isActive = false, 
  size = 20 
}) => {
  const colorClasses = isActive 
    ? 'text-[#72A8FD] group-hover:text-[#8BB8FE]' 
    : 'text-white group-hover:text-gray-200';

  return (
    <svg 
      width={size} 
      height={size * 1.1} // Maintain aspect ratio (20:22)
      viewBox="0 0 20 22" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorClasses} transition-colors duration-200 ${className}`}
    >
      <path 
        d="M17.7778 19.8V7.7H2.22222V19.8H17.7778ZM14.4444 0H16.6667V2.2H17.7778C18.3671 2.2 18.9324 2.43179 19.3491 2.84437C19.7659 3.25695 20 3.81652 20 4.4V19.8C20 20.3835 19.7659 20.9431 19.3491 21.3556C18.9324 21.7682 18.3671 22 17.7778 22H2.22222C0.988889 22 0 21.01 0 19.8V4.4C0 3.179 0.988889 2.2 2.22222 2.2H3.33333V0H5.55556V2.2H14.4444V0ZM4.44444 9.9H6.66667V12.1H4.44444V9.9ZM13.3333 9.9H15.5556V12.1H13.3333V9.9ZM8.88889 14.3H11.1111V16.5H8.88889V14.3ZM13.3333 14.3H15.5556V16.5H13.3333V14.3Z" 
        fill="currentColor"
      />
    </svg>
  );
}; 